
// Match the POST method shown in your screenshot
import http from "./http";

export const getFolders = async (school_id) => {
  // Postman shows a POST request to this endpoint
  return (await http.post(`school/getallimages?school_id=${school_id}`)).data;
};

// This uses the specific folder_download link from your JSON response
// export const downloadFullSchoolZip = (downloadUrl) => {
//   window.open(downloadUrl, "_self");
// };

export const downloadClassZip = async (schoolId) => {
  try {
    // We use window.location.href or an anchor tag for direct file downloads 
    // if the API is configured to return a file stream.
    // If it's a standard JSON API that returns a URL, fetch it first:
    
    const response = await fetch(`https://sramidcard.in/api/school/getallimages?school_id=${schoolId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    const data = await response.json();

    if (data.status && data.download_folder) {
      // Trigger the browser download
      window.location.href = data.download_folder;
    }
  } catch (error) {
    console.error("Download failed:", error);
  }
};

export const deleteClassImage = async ({ student_id, file }) => {
  try {
    const response = await http.get(
      `school/getallimages?delete=1&student_id=${student_id}&file=${encodeURIComponent(file)}`
    );

    return response.data;
  } catch (error) {
    console.error("Delete image error:", error);

    return {
      status: false,
      message: "Network error",
    };
  }
};

export const deleteClassFolder = async (school_id, teacher_id, class_id) => {
  const response = await http.get(`school/getallimages?delete=folder&school_id=${school_id}&teacher_id=${teacher_id}&class_id=${class_id}`);
  return response.data;
};

// Export School Uploaded Data Excel URL
export const getSchoolExcelUrl = (school_id) => {
  return `https://sramidcard.in/api/school/school_excel.php?school_id=${school_id}`;
};

// Export Teacher / App Uploaded Data Excel URL
export const getTeacherExcelUrl = (school_id) => {
  return `https://sramidcard.in/api/school/teacher_excel.php?school_id=${school_id}`;
};

// Download All Images for School (Full School ZIP)
export const getSchoolAllImagesDownloadUrl = (school_id) => {
  return `https://sramidcard.in/api/school/getallimages.php?download=all&school_id=${school_id}`;
};

// Download Class Folder(s) ZIP (Single or Comma-Separated Multiple Class IDs)
export const getClassFolderDownloadUrl = (school_id, class_ids) => {
  const ids = Array.isArray(class_ids) ? class_ids.join(",") : class_ids;
  return `https://sramidcard.in/api/school/getallimages.php?download=folder&school_id=${school_id}&class_id=${ids}`;
};